// Cabin Crew Training - Kabin Memuru Yetiştirme Programı
// 3 Ana Bölüm: Temel İngilizce, Kabin Memurluğu, Mülakat Hazırlık

export const PROGRAM = {
  // ==================== BÖLÜM 1: TEMEL İNGİLİZCE ====================
  basic_english: {
    id: 'basic_english',
    title: 'Temel İngilizce',
    subtitle: 'Sıfırdan başlayanlar için',
    icon: '📚',
    color: 'from-emerald-400 to-green-500',
    bgColor: 'bg-emerald-500',
    order: 1,
    requiredProgress: 0, // Baştan açık
    units: [
      {
        id: 1,
        title: 'Alfabe & Sayılar',
        icon: '🔤',
        lessons: [
          { id: 1, title: 'İngilizce Alfabe', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Alfabe Telaffuz', type: 'voice', duration: 15 },
          { id: 3, title: 'Sayılar 1-20', type: 'flashcard', duration: 10 },
          { id: 4, title: 'Sayılar 20-100', type: 'flashcard', duration: 10 },
          { id: 5, title: 'Pratik Quiz', type: 'quiz', duration: 5 },
        ]
      },
      {
        id: 2,
        title: 'Selamlaşma',
        icon: '👋',
        lessons: [
          { id: 1, title: 'Merhaba & Güle güle', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Nasılsınız?', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Tanışma Diyalogu', type: 'roleplay', duration: 15 },
          { id: 4, title: 'Telaffuz Pratiği', type: 'voice', duration: 10 },
          { id: 5, title: 'Selamlaşma Quiz', type: 'quiz', duration: 5 },
        ]
      },
      {
        id: 3,
        title: 'Soru Kalıpları',
        icon: '❓',
        lessons: [
          { id: 1, title: 'What / Where / When', type: 'flashcard', duration: 10 },
          { id: 2, title: 'How / Why / Who', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Can / Could / Would', type: 'flashcard', duration: 10 },
          { id: 4, title: 'Soru Pratiği', type: 'roleplay', duration: 15 },
          { id: 5, title: 'Soru Quiz', type: 'quiz', duration: 5 },
        ]
      },
      {
        id: 4,
        title: 'Zaman İfadeleri',
        icon: '⏰',
        lessons: [
          { id: 1, title: 'Saat Kaç?', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Günler & Aylar', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Bugün / Yarın / Dün', type: 'flashcard', duration: 10 },
          { id: 4, title: 'Zaman Diyalogu', type: 'roleplay', duration: 15 },
          { id: 5, title: 'Zaman Quiz', type: 'quiz', duration: 5 },
        ]
      },
      {
        id: 5,
        title: 'Yönler & Yerler',
        icon: '🧭',
        lessons: [
          { id: 1, title: 'Sağ / Sol / Düz', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Önde / Arkada / Yanda', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Nerede? Soruları', type: 'flashcard', duration: 10 },
          { id: 4, title: 'Yön Tarifi Pratiği', type: 'roleplay', duration: 15 },
          { id: 5, title: 'Yön Quiz', type: 'quiz', duration: 5 },
        ]
      },
      {
        id: 6,
        title: 'Yiyecek & İçecek',
        icon: '🍽️',
        lessons: [
          { id: 1, title: 'İçecekler', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Yiyecekler', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Sipariş Verme', type: 'roleplay', duration: 15 },
          { id: 4, title: 'Tercih Sorma', type: 'voice', duration: 10 },
          { id: 5, title: 'Yemek Quiz', type: 'quiz', duration: 5 },
        ]
      },
      {
        id: 7,
        title: 'Günlük Diyaloglar',
        icon: '💬',
        lessons: [
          { id: 1, title: 'Teşekkür & Rica', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Özür Dileme', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Yardım İsteme', type: 'roleplay', duration: 15 },
          { id: 4, title: 'Kibarca Reddetme', type: 'roleplay', duration: 15 },
          { id: 5, title: 'Diyalog Quiz', type: 'quiz', duration: 5 },
        ]
      },
      {
        id: 8,
        title: 'Temel İngilizce Sınavı',
        icon: '📝',
        lessons: [
          { id: 1, title: 'Kelime Tekrarı', type: 'flashcard', duration: 15 },
          { id: 2, title: 'Dinleme Testi', type: 'voice', duration: 10 },
          { id: 3, title: 'Konuşma Testi', type: 'roleplay', duration: 15 },
          { id: 4, title: 'Yazılı Test', type: 'quiz', duration: 20 },
          { id: 5, title: 'BÖLÜM 1 FİNAL', type: 'exam', duration: 30 },
        ]
      },
    ]
  },

  // ==================== BÖLÜM 2: KABİN MEMURLUĞU ====================
  cabin_crew: {
    id: 'cabin_crew',
    title: 'Kabin Memurluğu',
    subtitle: 'Havacılık İngilizcesi & Meslek Bilgisi',
    icon: '✈️',
    color: 'from-sky-400 to-blue-500',
    bgColor: 'bg-sky-500',
    order: 2,
    requiredProgress: 60, // %60 Temel İngilizce tamamlanmalı
    units: [
      {
        id: 9,
        title: 'Uçak Terminolojisi',
        icon: '🛩️',
        lessons: [
          { id: 1, title: 'Uçak Parçaları', type: 'flashcard', duration: 15 },
          { id: 2, title: 'Kabin Bölümleri', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Koltuk & Sıra Numaraları', type: 'flashcard', duration: 10 },
          { id: 4, title: 'Acil Çıkışlar', type: 'flashcard', duration: 10 },
          { id: 5, title: 'Terminoloji Quiz', type: 'quiz', duration: 10 },
        ]
      },
      {
        id: 10,
        title: 'Kabin Ekipmanları',
        icon: '🧰',
        lessons: [
          { id: 1, title: 'Güvenlik Ekipmanları', type: 'flashcard', duration: 15 },
          { id: 2, title: 'Servis Ekipmanları', type: 'flashcard', duration: 10 },
          { id: 3, title: 'İlk Yardım Çantası', type: 'flashcard', duration: 10 },
          { id: 4, title: 'Ekipman Kullanımı', type: 'video', duration: 15 },
          { id: 5, title: 'Ekipman Quiz', type: 'quiz', duration: 10 },
        ]
      },
      {
        id: 11,
        title: 'Hoşgeldiniz Anonsu',
        icon: '🎙️',
        lessons: [
          { id: 1, title: 'Anons Metni (İngilizce)', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Anons Metni (Türkçe)', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Telaffuz Pratiği', type: 'voice', duration: 15 },
          { id: 4, title: 'Anons Okuma', type: 'voice', duration: 15 },
          { id: 5, title: 'Anons Değerlendirme', type: 'exam', duration: 10 },
        ]
      },
      {
        id: 12,
        title: 'Güvenlik Demonstrasyonu',
        icon: '🛡️',
        lessons: [
          { id: 1, title: 'Emniyet Kemeri', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Oksijen Maskesi', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Can Yeleği', type: 'flashcard', duration: 10 },
          { id: 4, title: 'Demo Anlatımı', type: 'voice', duration: 15 },
          { id: 5, title: 'Güvenlik Quiz', type: 'quiz', duration: 10 },
        ]
      },
      {
        id: 13,
        title: 'Kalkış Öncesi Anonslar',
        icon: '📢',
        lessons: [
          { id: 1, title: 'Kemer Anonsu', type: 'voice', duration: 10 },
          { id: 2, title: 'Elektronik Cihaz Anonsu', type: 'voice', duration: 10 },
          { id: 3, title: 'Koltuk Pozisyonu Anonsu', type: 'voice', duration: 10 },
          { id: 4, title: 'Kapı Kapama Anonsu', type: 'voice', duration: 10 },
          { id: 5, title: 'Kalkış Anonsu Quiz', type: 'quiz', duration: 10 },
        ]
      },
      {
        id: 14,
        title: 'Servis Diyalogları',
        icon: '☕',
        lessons: [
          { id: 1, title: 'İçecek Servisi', type: 'roleplay', duration: 15 },
          { id: 2, title: 'Yemek Servisi', type: 'roleplay', duration: 15 },
          { id: 3, title: 'Özel İstekler', type: 'roleplay', duration: 15 },
          { id: 4, title: 'Duty Free Satış', type: 'roleplay', duration: 15 },
          { id: 5, title: 'Servis Quiz', type: 'quiz', duration: 10 },
        ]
      },
      {
        id: 15,
        title: 'Özel Yolcu Hizmetleri',
        icon: '👨‍👩‍👧',
        lessons: [
          { id: 1, title: 'Çocuklu Aileler', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Yaşlı Yolcular', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Engelli Yolcular', type: 'flashcard', duration: 10 },
          { id: 4, title: 'Özel Yolcu Diyalogu', type: 'roleplay', duration: 15 },
          { id: 5, title: 'Özel Yolcu Quiz', type: 'quiz', duration: 10 },
        ]
      },
      {
        id: 16,
        title: 'Türbülans & Uyarılar',
        icon: '⚠️',
        lessons: [
          { id: 1, title: 'Türbülans Anonsu', type: 'voice', duration: 10 },
          { id: 2, title: 'Kemer Uyarısı', type: 'voice', duration: 10 },
          { id: 3, title: 'Yolcu Sakinleştirme', type: 'roleplay', duration: 15 },
          { id: 4, title: 'Acil Durum Hazırlığı', type: 'flashcard', duration: 10 },
          { id: 5, title: 'Türbülans Quiz', type: 'quiz', duration: 10 },
        ]
      },
      {
        id: 17,
        title: 'Acil Durum Prosedürleri',
        icon: '🚨',
        lessons: [
          { id: 1, title: 'Tahliye Komutları', type: 'flashcard', duration: 15 },
          { id: 2, title: 'Tahliye Anonsu', type: 'voice', duration: 15 },
          { id: 3, title: 'Yangın Prosedürü', type: 'flashcard', duration: 10 },
          { id: 4, title: 'Su İnişi Prosedürü', type: 'flashcard', duration: 10 },
          { id: 5, title: 'Acil Durum Quiz', type: 'quiz', duration: 15 },
        ]
      },
      {
        id: 18,
        title: 'İniş Prosedürleri',
        icon: '🛬',
        lessons: [
          { id: 1, title: 'İniş Hazırlık Anonsu', type: 'voice', duration: 10 },
          { id: 2, title: 'İniş Anonsu', type: 'voice', duration: 10 },
          { id: 3, title: 'Bağlantı Bilgisi', type: 'flashcard', duration: 10 },
          { id: 4, title: 'Veda Anonsu', type: 'voice', duration: 10 },
          { id: 5, title: 'İniş Quiz', type: 'quiz', duration: 10 },
        ]
      },
      {
        id: 19,
        title: 'Şikayet Yönetimi',
        icon: '😤',
        lessons: [
          { id: 1, title: 'Dinleme & Empati', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Özür Cümleleri', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Çözüm Önerme', type: 'roleplay', duration: 15 },
          { id: 4, title: 'Zor Yolcu Senaryosu', type: 'roleplay', duration: 15 },
          { id: 5, title: 'Şikayet Quiz', type: 'quiz', duration: 10 },
        ]
      },
      {
        id: 20,
        title: 'Kabin Memurluğu Sınavı',
        icon: '🏆',
        lessons: [
          { id: 1, title: 'Terminoloji Tekrar', type: 'flashcard', duration: 15 },
          { id: 2, title: 'Anons Pratiği', type: 'voice', duration: 15 },
          { id: 3, title: 'Senaryo Testi', type: 'roleplay', duration: 20 },
          { id: 4, title: 'Yazılı Test', type: 'quiz', duration: 20 },
          { id: 5, title: 'BÖLÜM 2 FİNAL', type: 'exam', duration: 30 },
        ]
      },
    ]
  },

  // ==================== BÖLÜM 3: MÜLAKAT HAZIRLIK ====================
  interview_prep: {
    id: 'interview_prep',
    title: 'Mülakat Hazırlık',
    subtitle: 'Havayolu şirketlerine hazırlık',
    icon: '🎯',
    color: 'from-purple-400 to-violet-500',
    bgColor: 'bg-purple-500',
    order: 3,
    requiredProgress: 70, // %70 Kabin Memurluğu tamamlanmalı
    units: [
      {
        id: 21,
        title: 'Kendini Tanıt',
        icon: '🙋',
        lessons: [
          { id: 1, title: 'Tell me about yourself', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Güçlü Yönlerin', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Zayıf Yönlerin', type: 'flashcard', duration: 10 },
          { id: 4, title: 'Tanıtım Pratiği', type: 'voice', duration: 15 },
          { id: 5, title: 'Tanıtım Simülasyonu', type: 'roleplay', duration: 15 },
        ]
      },
      {
        id: 22,
        title: 'Sık Sorulan Sorular',
        icon: '❓',
        lessons: [
          { id: 1, title: 'Why cabin crew?', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Why this airline?', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Where do you see yourself?', type: 'flashcard', duration: 10 },
          { id: 4, title: 'Cevap Pratiği', type: 'voice', duration: 15 },
          { id: 5, title: 'SSS Simülasyonu', type: 'roleplay', duration: 15 },
        ]
      },
      {
        id: 23,
        title: 'Senaryo Soruları',
        icon: '🎭',
        lessons: [
          { id: 1, title: 'Zor Yolcu Senaryosu', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Acil Durum Senaryosu', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Ekip Çatışması Senaryosu', type: 'flashcard', duration: 10 },
          { id: 4, title: 'STAR Metodu', type: 'flashcard', duration: 10 },
          { id: 5, title: 'Senaryo Simülasyonu', type: 'roleplay', duration: 20 },
        ]
      },
      {
        id: 24,
        title: 'Assessment Day',
        icon: '👥',
        lessons: [
          { id: 1, title: 'Grup Tartışması', type: 'flashcard', duration: 10 },
          { id: 2, title: 'Takım Çalışması', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Sunum Yapma', type: 'flashcard', duration: 10 },
          { id: 4, title: 'İngilizce İletişim', type: 'voice', duration: 15 },
          { id: 5, title: 'Assessment Simülasyonu', type: 'roleplay', duration: 20 },
        ]
      },
      {
        id: 25,
        title: 'CV & Cover Letter',
        icon: '📄',
        lessons: [
          { id: 1, title: 'CV Yapısı', type: 'flashcard', duration: 10 },
          { id: 2, title: 'CV Örnekleri', type: 'flashcard', duration: 10 },
          { id: 3, title: 'Cover Letter Yazımı', type: 'flashcard', duration: 10 },
          { id: 4, title: 'Anahtar Kelimeler', type: 'flashcard', duration: 10 },
          { id: 5, title: 'CV Değerlendirme', type: 'quiz', duration: 15 },
        ]
      },
      {
        id: 26,
        title: 'Final Mock Mülakat',
        icon: '🏆',
        lessons: [
          { id: 1, title: 'Giriş & Tanışma', type: 'roleplay', duration: 15 },
          { id: 2, title: 'Teknik Sorular', type: 'roleplay', duration: 15 },
          { id: 3, title: 'Senaryo Soruları', type: 'roleplay', duration: 15 },
          { id: 4, title: 'İngilizce Test', type: 'voice', duration: 15 },
          { id: 5, title: 'BÖLÜM 3 FİNAL', type: 'exam', duration: 30 },
        ]
      },
    ]
  }
};

// Yardımcı fonksiyonlar
export const getSectionById = (sectionId) => PROGRAM[sectionId];

export const getAllSections = () => Object.values(PROGRAM).sort((a, b) => a.order - b.order);

export const getTotalLessons = () => {
  let total = 0;
  Object.values(PROGRAM).forEach(section => {
    section.units.forEach(unit => {
      total += unit.lessons.length;
    });
  });
  return total;
};

export const getTotalUnits = () => {
  let total = 0;
  Object.values(PROGRAM).forEach(section => {
    total += section.units.length;
  });
  return total;
};

// Toplam: 26 Ünite, 130 Ders
